/** Leuchtet kurz auf, wenn sich `v` ändert (nicht beim ersten Anzeigen). Zeigt Ursache und Wirkung beim Verschieben von Reglern. */
import { useEffect, useRef, useState } from 'react';
export function usePulse(v: unknown): boolean {
  const prev = useRef(v), [on, setOn] = useState(false);
  useEffect(() => {
    if (prev.current === v) return; prev.current = v; setOn(true);
    const t = setTimeout(() => setOn(false), 900); return () => clearTimeout(t);
  }, [v]);
  return on;
}
